export default "__VITE_ASSET__DJCf46zs__"